/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { UpdateProfile, UserLogin } from "../redux/userSlice";
import TextInput from "./TextInput";
import Loading from "./Loading";
import CustomButton from "./CustomButton";
import { apiRequest, handleFileUpload } from "../utils";
import { NoProfile } from "../assets";

const EditProfile = () => {
  const { user } = useSelector((state) => state.user);
  const [errMsg, setErrMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);
  const [coverPicture, setCoverPicture] = useState(null);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", defaultValues: { ...user } });

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setErrMsg("");

    try {
      // Upload profile & cover if selected
      const uriProfile =
        profilePicture && (await handleFileUpload(profilePicture));
      const uriCover = coverPicture && (await handleFileUpload(coverPicture));

      const { firstName, lastName, location, profession } = data;

      const res = await apiRequest({
        url: "/users/update-user",
        data: {
          firstName,
          lastName,
          location,
          profession,
          profileUrl: uriProfile ? uriProfile : user?.profileUrl,
          coverUrl: uriCover ? uriCover : user?.coverUrl,
        },
        method: "PUT",
        token: user?.token,
      });

      if (res?.status === "failed") {
        setErrMsg(res);
      } else {
        setErrMsg(res);
        const newUser = { token: res?.token, ...res?.user };
        dispatch(UserLogin(newUser));

        setTimeout(() => {
          dispatch(UpdateProfile(false));
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    dispatch(UpdateProfile(false));
  };

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-[#000] opacity-70"></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
        &#8203;

        {/* Modal */}
        <div
          className="inline-block align-bottom bg-primary rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full"
          role="dialog"
          aria-modal="true"
        >
          {/* Header */}
          <div className="flex justify-between px-6 pt-5 pb-2">
            <h2 className="font-medium text-xl text-ascent-1">Edit Profile</h2>
            <button className="text-ascent-1" onClick={handleClose}>
              <MdClose size={22} />
            </button>
          </div>

          {/* Form */}
          <form
            className="px-4 sm:px-6 flex flex-col gap-4"
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* Inputs */}
            <TextInput
              placeholder="First Name"
              label="First Name"
              type="text"
              register={register("firstName", {
                required: "First Name is required",
              })}
              styles="w-full"
              error={errors.firstName ? errors.firstName.message : ""}
            />

            <TextInput
              placeholder="Last Name"
              label="Last Name"
              type="text"
              register={register("lastName", {
                required: "Last Name is required",
              })}
              styles="w-full"
              error={errors.lastName ? errors.lastName.message : ""}
            />

            <TextInput
              placeholder="Profession"
              label="Profession"
              type="text"
              register={register("profession", {
                required: "Profession is required",
              })}
              styles="w-full"
              error={errors.profession ? errors.profession.message : ""}
            />

            <TextInput
              label="Location"
              placeholder="Location"
              type="text"
              styles="w-full"
              register={register("location", {
                required: "Location is required",
              })}
              error={errors.location ? errors.location.message : ""}
            />

            {/* Profile Image Upload */}
            <div>
              <label className="block text-sm font-medium text-ascent-2 mb-1">
                Profile Picture
              </label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => setProfilePicture(e.target.files[0])}
              />
              {(profilePicture || user?.profileUrl) && (
                <img
                  src={
                    profilePicture
                      ? URL.createObjectURL(profilePicture)
                      : user?.profileUrl ?? NoProfile
                  }
                  alt="profile preview"
                  className="mt-2 w-20 h-20 object-cover rounded-full"
                />
              )}
            </div>

            {/* Cover Image Upload */}
            <div>
              <label className="block text-sm font-medium text-ascent-2 mb-1">
                Cover Photo
              </label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => setCoverPicture(e.target.files[0])}
              />
              {(coverPicture || user?.coverUrl) && (
                <img
                  src={
                    coverPicture
                      ? URL.createObjectURL(coverPicture)
                      : user?.coverUrl ?? NoProfile
                  }
                  alt="cover preview"
                  className="mt-2 w-full h-32 object-cover rounded-md"
                />
              )}
            </div>

            {/* Error Message */}
            {errMsg?.message && (
              <span
                role="alert"
                className={`text-sm ${
                  errMsg?.status === "failed"
                    ? "text-red-500"
                    : "text-green-500"
                } mt-1`}
              >
                {errMsg?.message}
              </span>
            )}

            {/* Buttons */}
            <div className="py-5 sm:flex sm:flex-row-reverse border-t border-[#66666645]">
              {isSubmitting ? (
                <Loading />
              ) : (
                <CustomButton
                  title="Save Changes"
                  type="submit"
                  containerStyles="inline-flex justify-center rounded-md bg-[#1877F2] px-6 py-2 text-sm font-medium text-white"
                />
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
